// extracted by mini-css-extract-plugin
module.exports = {"BundleProductListSectionWrapper":"SelectedProductListUI_BundleProductListSectionWrapper__GKiBM","fadeInOpacity":"SelectedProductListUI_fadeInOpacity__KcFZU"};